module.exports = __webpack_public_path__ + "static/media/B.67fb0266.jpg";